var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCdc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 40,
    viewBox: "0 0 97 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=DB-CDC"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line",
    x1: 20.5,
    y1: 19.5,
    x2: 32.5,
    y2: 19.5,
    stroke: "#AED2FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Src"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 12,
    width: 24,
    height: 16,
    rx: 2,
    fill: "#AED2FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-database",
    clipPath: "url(#clip0_23673_349083)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M60.5 19.5C60.4976 18.8258 60.343 18.1609 60.0475 17.5548C59.7521 16.9488 59.3236 16.4173 58.794 16C59.5267 15.4225 60.0609 14.6306 60.3219 13.7349C60.583 12.8392 60.558 11.8843 60.2503 11.0035C59.9427 10.1227 59.3678 9.35991 58.6059 8.82149C57.844 8.28307 56.933 7.9959 56 8.00004H41C40.0671 7.9959 39.1561 8.28307 38.3942 8.82149C37.6322 9.35991 37.0573 10.1227 36.7497 11.0035C36.4421 11.8843 36.4171 12.8392 36.6782 13.7349C36.9392 14.6306 37.4733 15.4225 38.206 16C37.6746 16.4156 37.2447 16.9468 36.9491 17.5532C36.6535 18.1596 36.4999 18.8254 36.4999 19.5C36.4999 20.1747 36.6535 20.8405 36.9491 21.4469C37.2447 22.0533 37.6746 22.5845 38.206 23C37.4733 23.5776 36.9392 24.3695 36.6782 25.2652C36.4171 26.1609 36.4421 27.1158 36.7497 27.9966C37.0573 28.8774 37.6322 29.6402 38.3942 30.1786C39.1561 30.717 40.0671 31.0042 41 31H56C56.933 31.0042 57.844 30.717 58.6059 30.1786C59.3678 29.6402 59.9427 28.8774 60.2503 27.9966C60.558 27.1158 60.583 26.1609 60.3219 25.2652C60.0609 24.3695 59.5267 23.5776 58.794 23C59.3236 22.5828 59.7521 22.0513 60.0475 21.4453C60.343 20.8392 60.4976 20.1743 60.5 19.5ZM38.5 12.5C38.5 11.837 38.7634 11.2011 39.2323 10.7323C39.7011 10.2634 40.337 10 41 10H41.5V11C41.5 11.2653 41.6054 11.5196 41.7929 11.7072C41.9805 11.8947 42.2348 12 42.5 12C42.7653 12 43.0196 11.8947 43.2071 11.7072C43.3947 11.5196 43.5 11.2653 43.5 11V10H45.5V11C45.5 11.2653 45.6054 11.5196 45.7929 11.7072C45.9805 11.8947 46.2348 12 46.5 12C46.7653 12 47.0196 11.8947 47.2071 11.7072C47.3947 11.5196 47.5 11.2653 47.5 11V10H56C56.6631 10 57.299 10.2634 57.7678 10.7323C58.2366 11.2011 58.5 11.837 58.5 12.5C58.5 13.1631 58.2366 13.799 57.7678 14.2678C57.299 14.7367 56.6631 15 56 15H41C40.337 15 39.7011 14.7367 39.2323 14.2678C38.7634 13.799 38.5 13.1631 38.5 12.5V12.5ZM58.5 26.5C58.5 27.1631 58.2366 27.799 57.7678 28.2678C57.299 28.7367 56.6631 29 56 29H41C40.337 29 39.7011 28.7367 39.2323 28.2678C38.7634 27.799 38.5 27.1631 38.5 26.5C38.5 25.837 38.7634 25.2011 39.2323 24.7323C39.7011 24.2634 40.337 24 41 24H41.5V25C41.5 25.2653 41.6054 25.5196 41.7929 25.7072C41.9805 25.8947 42.2348 26 42.5 26C42.7653 26 43.0196 25.8947 43.2071 25.7072C43.3947 25.5196 43.5 25.2653 43.5 25V24H45.5V25C45.5 25.2653 45.6054 25.5196 45.7929 25.7072C45.9805 25.8947 46.2348 26 46.5 26C46.7653 26 47.0196 25.8947 47.2071 25.7072C47.3947 25.5196 47.5 25.2653 47.5 25V24H56C56.6631 24 57.299 24.2634 57.7678 24.7323C58.2366 25.2011 58.5 25.837 58.5 26.5ZM41 22C40.337 22 39.7011 21.7367 39.2323 21.2678C38.7634 20.799 38.5 20.1631 38.5 19.5C38.5 18.837 38.7634 18.2011 39.2323 17.7323C39.7011 17.2634 40.337 17 41 17H41.5V18C41.5 18.2653 41.6054 18.5196 41.7929 18.7072C41.9805 18.8947 42.2348 19 42.5 19C42.7653 19 43.0196 18.8947 43.2071 18.7072C43.3947 18.5196 43.5 18.2653 43.5 18V17H45.5V18C45.5 18.2653 45.6054 18.5196 45.7929 18.7072C45.9805 18.8947 46.2348 19 46.5 19C46.7653 19 47.0196 18.8947 47.2071 18.7072C47.3947 18.5196 47.5 18.2653 47.5 18V17H56C56.6631 17 57.299 17.2634 57.7678 17.7323C58.2366 18.2011 58.5 18.837 58.5 19.5C58.5 20.1631 58.2366 20.799 57.7678 21.2678C57.299 21.7367 56.6631 22 56 22H41Z",
    fill: "#265EDB"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Dest"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.5,
    y: 12,
    width: 24,
    height: 16,
    rx: 2,
    fill: "#AED2FF"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    x1: 64.5,
    y1: 19.5,
    x2: 76.5,
    y2: 19.5,
    stroke: "#AED2FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23673_349083"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(36.5 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdc);
export default __webpack_public_path__ + "static/media/cdc.076b2d8d42526421684f441c65fd7e44.svg";
export { ForwardRef as ReactComponent };